import { Injectable } from '@angular/core';
import { gql, Query } from 'apollo-angular';

import { Query as RootQuery } from 'graphql/models/generated';

export const PRODUCT_POSITIONS_ASSIGNMENTS_QUERY = gql`
  query productPositionsAssignments(
    $documentVersion: DocumentVersionInput!
    $lineIds: [String]
    $parentLineId: String
    $hideProductValues: Boolean = false
    $hidePositionValues: Boolean = false
    $hideValues: Boolean = false
  ) {
    productPositionsAssignments(
      documentVersion: $documentVersion,
      lineIds: $lineIds,
      parentLineId: $parentLineId
    ) {
      lineId
      productAssignmentsValues @skip(if: $hideProductValues) {
        id
        varName
        name
        value
      }
      positionAssignmentsValues @skip(if: $hidePositionValues) {
        id
        varName
        name
        value
      }
      assignmentsValues @skip(if: $hideValues) {
        id
        varName
        name
        value
      }
    }
  }
`;

@Injectable({ providedIn: 'root' })
export class ProductPositionsAssignmentsQuery extends Query<RootQuery> {
  document = PRODUCT_POSITIONS_ASSIGNMENTS_QUERY;
}
